<template>
	<div
		class="fixed bottom-0 lg:top-0 lg:left-0 h-16 lg:h-screen w-screen lg:w-20 bg-slate-800 text-slate-500 p-2 lg:py-5 flex flex-row lg:flex-col justify-between items-center">
		<!-- LOGO START -->
		<a :href="route('home')">
			<img src="/adiral-logo.png" class="w-2/3 lg:w-auto" alt="" />
		</a>
		<!-- LOGO END -->
		<!-- MAIN LINKS START -->
		<div class="flex-grow flex flex-row lg:flex-col text-xl gap-5 items-center justify-center">
			<Link :href="route('home')" :class="{ 'text-slate-50': route().current('home') }" class="hover:text-slate-50">
				<i :class="route().current('home') ? 'fa-solid fa-house' : 'fa-regular fa-house'"></i>
			</Link>
			<Link :href="route('contacts.index')" :class="{ 'text-slate-50': route().current('contacts.*') }" class="hover:text-slate-50">
				<i :class="route().current('contacts.*') ? 'fa-solid fa-user' : 'fa-regular fa-user'"></i>
			</Link>
			<Link :href="route('structures.index')" :class="{ 'text-slate-50': route().current('structures.*') }" class="hover:text-slate-50">
				<i :class="route().current('structures.*') ? 'fa-solid fa-hospital' : 'fa-regular fa-hospital'"></i>
			</Link>
			<Link :href="route('contrats.index')" :class="{ 'text-slate-50': route().current('contrats.*') }" class="hover:text-slate-50">
				<i :class="route().current('contrats.*') ? 'fa-solid fa-file-invoice' : 'fa-regular fa-file-invoice'"></i>
			</Link>
		</div>
		<!-- MAIN LINKS END -->
		<!-- USER LINKS START -->
		<div class="flex flex-row lg:flex-col gap-5 text-2xl items-center">
			<Link
				:href="route('admin.users.map')"
				:class="{
					'text-slate-50': route().current('admin.users.map'),
				}">
				<i :class="route().current('admin.users.map') ? 'fa-solid fa-location-dot' : 'fa-regular fa-location-dot'"></i>
			</Link>
			<Link
				:href="route('calendar.users', page.props.auth.user.id)"
				:class="{
					'text-slate-50': route().current('calendar.users'),
				}">
				<i :class="route().current('calendar.users') ? 'fa-solid fa-calendar' : 'fa-regular fa-calendar'"></i>
			</Link>
			<Link
				v-if="page.props.auth.user.role === 'admin'"
				:href="route('admin.index')"
				:class="{
					'text-slate-50': route().current('admin.*'),
				}">
				<i :class="route().current('admin.*') ? 'fa-solid fa-lock' : 'fa-regular fa-lock'"></i>
			</Link>
		</div>
		<!-- USER LINKS END -->
	</div>
</template>

<script setup>
	import { usePage } from '@inertiajs/vue3';

	const page = usePage();
</script>
